import { getItem } from '../helpers/object-helper';
import { optionValueForGuiConfigurationState } from '../helpers/gui-helper';
import { goolgeLibMapsGet } from '../helpers/google-lib-discover-helper';

const googleMaps = goolgeLibMapsGet();
const confUrlBasePathname = process.env.PUBLIC_URL;

const confData = {
    // web api
    api: {
        development: {
            baseUrl: 'http://localhost:3001'
            //baseUrl: 'https://bernoulli.amtek.site/iesccapitest'
        },
        production: {
            baseUrl: 'https://bernoulli.amtek.site/iesccapi/'
            //baseUrl: 'https://bernoulli.amtek.site/iesccapitest'
        }
    },
    // gui data
    gui: {
        loading: {
            label: 'Stiamo elaborando la tua richiesta'
        },
        images: {
            basePath: (process.env.NODE_ENV === 'development') ? process.env.PUBLIC_URL + '/images' : `${ confUrlBasePathname }/images`
        },
        docs: {
            basePath: (process.env.NODE_ENV === 'development') ? process.env.PUBLIC_URL + '/docs' : `${ confUrlBasePathname }/docs`
        },
        map: {
            _k: 'AIzaSyDaJLwsUmFr05RY1WbrzQ-V8suIicSFzIg',
            imageGeneratorUrl: 'https://maps.googleapis.com/maps/api/staticmap',
            address: 'Piazza Duomo, Milano',
            addressMarkerIcon: {
                path: googleMaps ? googleMaps.SymbolPath.BACKWARD_CLOSED_ARROW : null,
                fillColor: '#FF9D2E',
                fillOpacity: 1,
                strokeColor: 'white',
                strokeWeight: 1,
                scale: 4,
                rotation: 30
            },
            mapOptions: {
                zoom: 18,
                mapTypeId: googleMaps ? googleMaps.MapTypeId.SATELLITE : null
            },
            drawingManagerOptions: {},
            polygonOptions: {
                strokeWeight: 0,
                fillOpacity: 0.75,
                fillColor: '#FF9D2E',
                editable: true,
                draggable: true
            },
            mapStaticImage: {
                generatorUrl: 'https://maps.googleapis.com/maps/api/staticmap',
                size: '400x400',
                sizeInQuotationsComponent: '463x204',//'331x204',
                scale: 1
            }
        },
        steps: {
            step1: {
                dataId: 'configuration.tipo_installazione',
                title: 'Configura la tua caldaia',
                text: 'Vuoi installare una nuova caldaia o sostituirne una vecchia?',
                options: [
                    {
                        label: 'Nuova installazione: detrazione fiscale 50%',
                        value: 'nuova'
                    },
                    {
                        label: 'Sostituzione vecchia installazione: detrazione fiscale 65%',
                        value: 'sostituzione'
                    }
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione',
                //nextAuto: false // activate this to disable nextAuto feature on the step
            },
            step2: {
                dataId: 'configuration.tipo_riscaldamento',
                title: 'Configura la tua caldaia',
                text: 'Il riscaldamento della casa è autonomo?',
                options: [
                    {
                        label: 'Si',
                        value: 'autonomo'
                    },
                    {
                        label: 'No',
                        value: 'non_autonomo'
                    }
                ],
                nextValidationFailMessage: 'Per accedere all’offerta caldaia è necessario avere un impianto di riscaldamento autonomo.'
            },
            step3: {
                dataId: 'configuration.dove_ambiente',
                title: 'Configura la tua caldaia',
                text: 'Dove si trova la caldaia?',
                options: [
                    {
                        label: 'Cucina',
                        value: 'cucina'
                    },
                    {
                        label: 'Bagno',
                        value: 'bagno'
                    },
                    {
                        label: 'Cantina',
                        value: 'cantina'
                    },
                    {
                        label: 'Mansarda',
                        value: 'mansarda'
                    },
                    {
                        label: 'Locale Tecnico',
                        value: 'locale_tecnico'
                    },
                    {
                        label: 'Esterno',
                        value: 'esterno'
                    }
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step4: {
                dataId: 'configuration.dove_posizione',
                title: 'Configura la tua caldaia',
                text: 'Dove è posizionata la caldaia?',
                options: [
                    {
                        label: 'Al muro',
                        value: 'al_muro'
                    },
                    {
                        label: 'Appoggiata a terra',
                        value: 'appoggiata_a_terra'
                    }
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step5: {
                dataId: 'configuration.alimentazione',
                title: 'Configura la tua caldaia',
                text: 'Come è alimentata la caldaia?',
                options: [
                    {
                        label: 'Metano',
                        value: 'metano'
                    },
                    {
                        label: 'GPL',
                        value: 'gpl'
                    },
                    {
                        label: 'Gasolio',
                        value: 'gasolio'
                    },
                    {
                        label: 'Non lo so',
                        value: 'non_lo_so'
                    }
                ],
                nextValidationFailMessage: 'La caldaia alimentata a gasolio non è sostituibile, in quanto è necessario che l\'impianto sia alimentato a GPL o metano.'
            },
            step6: {
                dataId: 'configuration.potenza',
                title: 'Configura la tua caldaia',
                text: 'Qual è la potenza della caldaia?',
                options: [
                    {
                        label: '<25 kW',
                        value: '<25_kW'
                    },
                    {
                        label: '26-28 kW',
                        value: '26-28_kW'
                    },
                    {
                        label: '29-33 kW',
                        value: '29-33_kW'
                    },
                    {
                        label: '>34 kW',
                        value: '>34_kW'
                    }
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step7: {
                title: 'Configura la tua caldaia',
                valvole: {
                    dataId: 'configuration.termosifoni_valvole',
                    title: 'Configura la tua caldaia',
                    text: 'I termosifoni sono dotati di valvole termostatiche',
                    options: [
                        {
                            label: 'Si',
                            value: 'si'
                        },
                        {
                            label: 'No',
                            value: 'no'
                        },
                        {
                            label: 'Non ho termosifoni in casa - riscaldamento a pavimento',
                            value: 'assenti'
                        },
                        {
                            label: 'Valvole monotubo',
                            value: 'valvole_monotubo'
                        }
                    ]
                },
                termosifoni: {
                    dataId: 'configuration.termosifoni_numero',
                    title: 'Configura la tua caldaia',
                    text: 'Quanti termosifoni ci sono?',
                    info: 'Inserisci il numero dei termosifoni',
                    options: [
                        {
                            label: 'Scegli...',
                            value: 'Scegli...'
                        },
                        {
                            label: '1',
                            value: '1'
                        },
                        {
                            label: '2',
                            value: '2'
                        },
                        {
                            label: '3',
                            value: '3'
                        },
                        {
                            label: '4',
                            value: '4'
                        },
                        {
                            label: '5',
                            value: '5'
                        },
                        {
                            label: '6',
                            value: '6'
                        },
                        {
                            label: '7',
                            value: '7'
                        },
                        {
                            label: '8',
                            value: '8'
                        },
                        {
                            label: '9',
                            value: '9'
                        },
                        {
                            label: '10',
                            value: '10'
                        },
                        {
                            label: '11',
                            value: '11'
                        },
                        {
                            label: '12',
                            value: '12'
                        },
                        {
                            label: '13',
                            value: '13'
                        },
                        {
                            label: '14',
                            value: '14'
                        },
                        {
                            label: '15',
                            value: '15'
                        }
                    ]
                },
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione e, se richiesto, il numero di termosifoni'
            },
            step8: {
                dataId: 'configuration.marchi',
                title: 'Configura la tua caldaia',
                text: 'Ha preferenze di marchi?',
                options: [
                    {
                        label: 'Ferroli',
                        value: 'Ferroli'
                    },
                    {
                        label: 'Immergas',
                        value: 'Immergas'
                    },
                    {
                        label: 'Vaillant',
                        value: 'Vaillant'
                    },
                    {
                        label: 'Non ho preferenze',
                        value: 'Non ho preferenze'
                    }
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step9: {
                dataId: 'configuration.scarico_4mt_discesa',
                title: 'Configura la tua caldaia',
                text: 'Lo scarico più vicino si trova a meno di 4 mt di distanza con tratto sempre in discesa?',
                options: [
                    {
                        label: 'Si',
                        value: 'si'
                    },
                    {
                        label: 'No',
                        value: 'no'
                    },
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step10: {
                dataId: 'configuration.box_coibentato',
                title: 'Configura la tua caldaia',
                text: 'In caso di caldaia esterna, è necessario un box coibentato?',
                options: [
                    {
                        label: 'Si',
                        value: 'si'
                    },
                    {
                        label: 'No',
                        value: 'no'
                    },
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step11: {
                dataId: 'configuration.scarico_di_condensa',
                title: 'Configura la tua caldaia',
                text: 'Lo scarico di condensa è convogliato direttamente in fogna nera o in fognatura pluviale per acque piovane senza dispersione?',
                options: [
                    {
                        label: 'Fognatura bianca senza dispersione',
                        value: 'fognatura_bianca'
                    },
                    {
                        label: 'Fognatura Nera',
                        value: 'fognatura_nera'
                    },
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step12: {
                dataId: 'configuration.parete_cemento_pietra',
                title: 'Configura la tua caldaia',
                text: 'La parete da forare è in cemento armato o pietra maggiore di 30cm?',
                options: [
                    {
                        label: 'Si',
                        value: 'si'
                    },
                    {
                        label: 'No',
                        value: 'no'
                    },
                ],
                nextValidationFailMessage: 'E\' necessario selezionare un\'opzione'
            },
            step13: {
                dataId: 'configuration.importo_bolletta_gas',
                title: 'Configura la tua caldaia',
                text: 'Qual è l’importo annuo della bolletta del gas?',
                options: [],
                nextValidationFailMessage: 'E\' necessario indicare un\'importo',
                nextAuto: false
            },
        },
        quotations: {
            title: 'Proposta installativa'
        },
        configurationState: {
            user: {
                exclude: ['pv', 'city', 'postalCode']
            },
            configuration: {
                exclude: ['electricityConsumptionPersone', 'electricityConsumptionCost']
            }
        }
    },
    // user data
    user: {
        address: {
            label: 'Indirizzo',
            webServiceParamName: 'indirizzo'
        },
        pv: {
            label: 'Provincia'
        },
        city: {
            label: 'Città'
        },
        postalCode: {
            label: 'Codice postale'
        },
        email: {
            label: 'Email'
        }
    },
    // quotationsForm data
    quotationsForm: {
        nome: {
            label: 'Nome'
        },
        cognome: {
            label: 'Cognome'
        },
        email: {
            label: 'Email'
        },
        ragioneSociale: {
            label: 'Ragione sociale'
        },
        indirizzo: {
            label: 'Indirizzo'
        },
        numerocivico: {
            label: 'Numero civico',
            webServiceParamName: 'numeroCivico'
        },
        comune: {
            label: 'Comune'
        },
        cap: {
            label: 'CAP'
        },
        provincia: {
            label: 'Provincia'
        },
        tipoImmobile: {
            label: 'Tipo di appartamento'
        },
        emailCommerciale: {
            label: 'Email agente'
        },
    },
    // Configuration for ConfigurationState Component
    configuration: {
        tipo_installazione: {
            label: 'Tipo di installazione',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step1;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        tipo_riscaldamento: {
            label: 'Riscaldamento autonomo',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step2;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        dove_ambiente: {
            label: 'Dove si trova la caldaia',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step3;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        dove_posizione: {
            label: 'Dove è posizionata la caldaia',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        alimentazione: {
            label: 'Come è alimentata la caldaia?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step5;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        potenza: {
            label: 'Qual è la potenza della caldaia?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step6;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        termosifoni_valvole: {
            label: 'I termosifoni sono dotati di valvole termostatiche',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step7.valvole;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        termosifoni_numero: {
            label: 'Quanti termosifoni ci sono?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step7.termosifoni;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        marchi: {
            label: 'Ha preferenze di marchi?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step8;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        scarico_4mt_discesa: {
            label: 'Lo scarico più vicino si trova a meno di 4 mt di distanza con tratto sempre in discesa?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step9;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        box_coibentato: {
            label: 'In caso di caldaia esterna, è necessario un box coibentato?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step10;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        scarico_di_condensa: {
            label: 'Lo scarico di condensa è convogliato direttamente in fogna nera o in fognatura pluviale per acque piovane senza dispersione?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step11;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },
        parete_cemento_pietra: {
            label: 'La parete da forare è in cemento armato o pietra >30cm?',
            valueGuiForConfigurationStateFn: value => {
                const confDataForStep = confData.gui.steps.step12;
                return optionValueForGuiConfigurationState(confDataForStep, value);
            }
        },  
        importo_bolletta_gas: {
            label: 'Qual è l’importo annuo della bolletta del gas?',
            valueGuiForConfigurationStateFn: value => {
                return value;
            }
        },       
    },
    externalUrls: {
        ies: 'https://ies-solare.com/',
        unauthorized: 'https://preventivatore.ies-solare.com/caldaia/'
    }
};

/**
 * Returns the application's url base path
 * @returns {String}
 */
const getConfUrlBasePathName = () => confUrlBasePathname;

/**
 * Returns a configuration item
 * @param {String} itemPath
 * @param {Object} object
 * @return {Mixed}
 * 
 * @usage
 *  const item = getConfItem('configuration');
 *  const item = getConfItem('configuration.roofArea.label'); 
 */
const getConfItem = (itemPath, object = confData) => {
    return getItem(itemPath, object);
};

const getLabel = (itemPath, defaultLabel = '') => {
    return getConfItem(itemPath + '.label') || defaultLabel;
};

const getMeasureUnit = (itemPath, defaultMeasureUnit = '') => {
    return getConfItem(itemPath + '.measureUnit') || defaultMeasureUnit;
};

const getValueProcessFn = (itemPath) => {
    return getConfItem(itemPath + '.valueProcessFn');
};

const getValueGuiFn = (itemPath) => {
    return getConfItem(itemPath + '.valueGuiFn');
};

const getValueGuiForConfigurationStateFn = (itemPath) => {
    return getConfItem(itemPath + '.valueGuiForConfigurationStateFn');
};

const getWebServiceParamName = (itemPath) => {
    return getConfItem(itemPath + '.webServiceParamName');
};

const getWebServiceValueFn = (itemPath) => {
    return getConfItem(itemPath + '.webServiceValueFn');
};

const getStepConf = (stepNum) => {
    return getConfItem('gui.steps.step' + stepNum);
};

const getStepTitle = (stepNum) => {
    return getStepConf(stepNum)
        ? getStepConf(stepNum).title
        : '';
};

const getStepsNumber = () => {
    return Object.keys(getConfItem('gui.steps')).length;
};

const getQuotationsTitle = () => {
    return getConfItem('gui.quotations.title');
};

export default confData;
export {
    getConfUrlBasePathName,
    getConfItem,
    getLabel,
    getMeasureUnit,
    getValueProcessFn,
    getValueGuiFn,
    getValueGuiForConfigurationStateFn,
    getWebServiceParamName,
    getWebServiceValueFn,
    getStepConf,
    getStepTitle,
    getStepsNumber,
    getQuotationsTitle
};